var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "go-card-main-grid" },
    [
      _vm._l(_vm.filteredReportCards, function (item, index) {
        return _c("report-card", { key: index, attrs: { "form-model": item } })
      }),
      _vm._v(" "),
      _vm._l(_vm.resourceItems, function (item, index) {
        return [
          item.isGroup
            ? _c("group-card-v2", {
                key: index,
                attrs: { groupData: item },
                on: {
                  "view-detail": function (el) {
                    return _vm.viewDetail(el)
                  },
                },
              })
            : item.originParentDocDetail.media_type[0] === "CHAT_HISTORY"
            ? _c("chat-history-card", {
                key: index,
                attrs: {
                  title: item.title,
                  "conversation-id": item.docId,
                  description: _vm.getContent(item),
                  date: _vm.getLastUpdate(item),
                  "is-bookmark": item.isBookmarked,
                  "link-title": _vm.convertTitle(item),
                  "chat-page": _vm.getChatPage(item),
                  type: _vm.getChatPage(item),
                  "report-id": _vm.getReportId(item),
                  "briefing-id": _vm.getBriefingId(item),
                  isScrapPage: true,
                },
                on: {
                  share: _vm.copyShareLink,
                  "view-history": function ($event) {
                    return _vm.viewHistoryConversation(item)
                  },
                  close: _vm.closeHistoryConversation,
                  addBookmark: function ($event) {
                    return _vm.updateBookmark(item)
                  },
                },
              })
            : item.originParentDocDetail.media_type[0] === "VIDEO"
            ? _c("video-card", {
                key: index,
                attrs: {
                  "form-model": item,
                  "is-hide-options": _vm.isHideOptions,
                  "is-hide-add-reference": _vm.isHideAddReference,
                  "is-hide-goover": _vm.isHideGoover,
                  "is-hide-hidden": _vm.isHideHidden,
                  "is-hide-shared": true,
                },
                on: {
                  hide: function ($event) {
                    return _vm.hide(item, index, "footer")
                  },
                  share: function ($event) {
                    return _vm.share(item)
                  },
                  "view-detail": function ($event) {
                    return _vm.viewDetail(item)
                  },
                  "toggle-resource": function ($event) {
                    return _vm.toggle2Resource(item, index)
                  },
                  "select-user-social": function ($event) {
                    return _vm.onSelectUserSocial(item.userProfile.userKey)
                  },
                  "add-to-reference": function ($event) {
                    return _vm.addToReference(item)
                  },
                  goover: function ($event) {
                    return _vm.addToNewAgentBriefing(item)
                  },
                },
              })
            : item.originParentDocDetail.media_type[0] === "REPORT"
            ? _c("report-card", {
                key: index,
                attrs: {
                  "form-model": item,
                  "is-hide-options": false,
                  "is-hide-add-reference": _vm.isHideAddReference,
                  "is-hide-goover": _vm.isHideGoover,
                  "is-hide-hidden": _vm.isHideHidden,
                  "is-hide-shared": _vm.isHideShared,
                },
                on: {
                  hide: function ($event) {
                    return _vm.hide(item, index, "footer")
                  },
                  share: function ($event) {
                    return _vm.share(item)
                  },
                  "view-detail": function ($event) {
                    return _vm.viewDetail(item)
                  },
                  "toggle-resource": function ($event) {
                    return _vm.toggle2Resource(item, index)
                  },
                  "select-user-social": function ($event) {
                    return _vm.onSelectUserSocial(item.userProfile.userKey)
                  },
                  "add-to-reference": function ($event) {
                    return _vm.addToReference(item)
                  },
                  goover: function ($event) {
                    return _vm.addToNewAgentBriefing(item)
                  },
                },
              })
            : item.originParentDocDetail.media_type[0] === "TOPIC_SUMMARY"
            ? _c("topic-card", {
                key: index,
                attrs: {
                  "form-model": item,
                  "is-hide-options": _vm.isHideOptions,
                  "is-hide-add-reference": _vm.isHideAddReference,
                  "is-hide-goover": _vm.isHideGoover,
                  "is-hide-hidden": _vm.isHideHidden,
                  "is-hide-shared": _vm.isHideShared,
                },
                on: {
                  hide: function ($event) {
                    return _vm.hide(item, index, "footer")
                  },
                  share: function ($event) {
                    return _vm.share(item)
                  },
                  "view-detail": function ($event) {
                    return _vm.viewDetail(item)
                  },
                  "toggle-resource": function ($event) {
                    return _vm.toggle2Resource(item, index)
                  },
                  "select-user-social": function ($event) {
                    return _vm.onSelectUserSocial(item.userProfile.userKey)
                  },
                  "add-to-reference": function ($event) {
                    return _vm.addToReference(item)
                  },
                  goover: function ($event) {
                    return _vm.addToNewAgentBriefing(item)
                  },
                },
              })
            : item.originParentDocDetail.media_type[0] === "COMPANY" &&
              _vm.language == "ko"
            ? _c("company-card-v2", {
                key: index,
                class: "cmp_bp_id_" + item.cmp_bp_id,
                attrs: {
                  "form-model": item,
                  "is-hide-options": _vm.isHideOptions,
                  "is-hide-add-reference": _vm.isHideAddReference,
                  "is-hide-goover": _vm.isHideGoover,
                  "is-hide-hidden": _vm.isHideHidden,
                  "is-hide-shared": _vm.isHideShared,
                },
                on: {
                  "view-detail": function ($event) {
                    return _vm.viewDetail(item)
                  },
                  "view-detail-report": _vm.viewDetail,
                  "toggle-resource": function ($event) {
                    return _vm.toggle2Resource(item, index)
                  },
                  hide: function ($event) {
                    return _vm.hide(item, index, "footer")
                  },
                  share: function ($event) {
                    return _vm.share(item)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          (item.originParentDocDetail.media_type[0] !== "TOPIC_SUMMARY" &&
            item.originParentDocDetail.media_type[0] !== "COMPANY" &&
            item.originParentDocDetail.media_type[0] !== "REPORT" &&
            item.originParentDocDetail.media_type[0] !== "VIDEO" &&
            item.originParentDocDetail.media_type[0] !== "CHAT_HISTORY") ||
          item.originParentDocDetail.media_type[0] === "PODCAST"
            ? _c("discovery-card", {
                key: index,
                attrs: {
                  "form-model": item,
                  "is-hide-options": _vm.isHideOptions,
                  "is-hide-add-reference": _vm.isHideAddReference,
                  "is-hide-goover": _vm.isHideGoover,
                  "is-hide-hidden": _vm.isHideHidden,
                  "is-hide-shared": true,
                },
                on: {
                  hide: function ($event) {
                    return _vm.hide(item, index, "footer")
                  },
                  share: function ($event) {
                    return _vm.share(item)
                  },
                  "view-detail": function ($event) {
                    return _vm.viewDetail(item)
                  },
                  "toggle-resource": function ($event) {
                    return _vm.toggle2Resource(item, index)
                  },
                  "select-user-social": function ($event) {
                    return _vm.onSelectUserSocial(item.userProfile.userKey)
                  },
                  "add-to-reference": function ($event) {
                    return _vm.addToReference(item)
                  },
                  goover: function ($event) {
                    return _vm.addToNewAgentBriefing(item)
                  },
                },
              })
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _c("chat-history-modal", {
        attrs: { open: _vm.historyOpenModal, item: _vm.currentConversation },
        on: {
          close: _vm.closeHistoryConversation,
          bookmark: _vm.updateBookmarkForDetail,
          share: _vm.copyShareLink,
        },
      }),
      _vm._v(" "),
      _vm._t("loading"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }